import { useEffect, useState } from "react";
import { Download, X, Share, Plus } from "lucide-react";
import { toast } from "sonner";

const isIOS = () => typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true);

// "Download / Add to Home Screen" button. Triggers the native install prompt
// where supported, and shows iOS instructions otherwise.
export function InstallButton({ variant = "sidebar" }) {
  const [installed, setInstalled] = useState(isStandalone());
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const onInstalled = () => setInstalled(true);
    window.addEventListener("vs:installed", onInstalled);
    return () => window.removeEventListener("vs:installed", onInstalled);
  }, []);

  if (installed) return null;

  const install = async () => {
    const dp = window.deferredInstallPrompt;
    if (dp) {
      dp.prompt();
      const { outcome } = await dp.userChoice;
      if (outcome === "accepted") toast.success("Installing VirtuStars…");
      window.deferredInstallPrompt = null;
      return;
    }
    if (isIOS()) { setShowIOS(true); return; }
    toast("To install: open your browser menu and choose Install / Add to Home Screen");
  };

  const classes = variant === "hero"
    ? "inline-flex items-center gap-2 btn-gold rounded-full px-5 py-2.5 text-sm font-semibold"
    : "w-full flex items-center justify-center gap-2 btn-gold rounded-full px-3 py-2 text-sm font-semibold";

  return (
    <>
      <button onClick={install} className={classes} data-testid="install-app-btn">
        <Download size={16} /> Download App
      </button>
      {showIOS && (
        <div className="fixed inset-0 z-[70] bg-black/70 flex items-end sm:items-center justify-center p-4" onClick={() => setShowIOS(false)} data-testid="ios-install-modal">
          <div className="surface rounded-2xl p-6 w-full max-w-sm relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setShowIOS(false)} className="absolute top-4 right-4 text-muted-foreground"><X size={18} /></button>
            <div className="flex items-center gap-2 mb-2"><Download size={18} className="text-gold" /><h3 className="font-display font-bold text-lg">Add VirtuStars to Home Screen</h3></div>
            <ol className="text-sm text-muted-foreground space-y-3 mt-3">
              <li className="flex items-center gap-2">1. Tap the <Share size={15} className="inline text-eblue" /> <span className="text-white">Share</span> button in Safari</li>
              <li className="flex items-center gap-2">2. Choose <Plus size={15} className="inline text-eblue" /> <span className="text-white">Add to Home Screen</span></li>
              <li>3. Tap <span className="text-white">Add</span> — VirtuStars appears on your home screen</li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
